import React, { useEffect, useState } from 'react';
import { Grid, Box } from '@mui/material';
import './PopupModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import * as _ from 'lodash';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import { personalInfoType } from '../../../interfaces/myProfile/personalDetails/personalInfo';
import {
  validateEmail,
  validateMobileNumberWithCountryCode,
} from '../../../configs/utils';
import toast from 'react-hot-toast';
import Compdirection from '../../../themes/CompDirection';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: personalInfoType) => void;
  allCountires: [];
  allGenders: [];
  allMaritalStatus: [];
  selectedEmployeeDetail: personalInfoType;
  allStates: [];
  selectedCountryId: (countryId: any) => void;
  trans?: any;
}

const PopupModalPresenter = ({
  isModalOpen,
  closeModal,
  allCountires,
  allStates,
  allGenders,
  allMaritalStatus,
  selectedEmployeeDetail,
  selectedCountryId,
  callBackHandleClockIn,
  trans,
}: ModalProps) => {
  const [firstName, setFirstName] = useState(selectedEmployeeDetail.firstName);
  const [lastName, setLastName] = useState(selectedEmployeeDetail.lastName);
  const [maritalStatus, setMaritalStatus] = useState(
    selectedEmployeeDetail.martialStatus,
  );
  const [maritalStatusId, setMaritalStatusId] = useState(
    selectedEmployeeDetail.maritalStatusId,
  );
  const [countryId, setCountryId] = useState(selectedEmployeeDetail.countryId);
  const [stateId, setStateId] = useState(selectedEmployeeDetail.stateId);

  const [genderId, setGenderId] = useState(selectedEmployeeDetail.genderId);
  const [email, setEmail] = useState(selectedEmployeeDetail.email);
  const [phone, setPhone] = useState(selectedEmployeeDetail.phone);
  const [education, setEducation] = useState(selectedEmployeeDetail.education);
  const [religious, setReligious] = useState(selectedEmployeeDetail.religious);
  const [nationality, setNationality] = useState(
    selectedEmployeeDetail.nationalityName,
  );
  const [nationalityId, setNationalityId] = useState(
    selectedEmployeeDetail.nationalityId,
  );
  const [dob, setDOB] = useState<any>(new Date(selectedEmployeeDetail.DOB));
  const [countryName, setCountryName] = useState(
    selectedEmployeeDetail.country,
  );
  const [stateName, setStateName] = useState(selectedEmployeeDetail.state);
  const [gender, setGender] = useState(selectedEmployeeDetail.gender);

  useEffect(() => {
    selectedCountryId(selectedEmployeeDetail.countryId);
  }, []);
  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      selectedCountryId(cnty.id);
      setCountryName(countryName);
    }
  };
  const handleSetNationality = (NationalityName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === NationalityName;
    });
    if (country.length) {
      const cnty = country[0];
      setNationalityId(cnty.id);
      setNationality(countryName);
    }
  };

  const handleSetState = (stateName: any) => {
    const state = _.filter(allStates, function (s: any) {
      return s.name === stateName;
    });
    if (state.length) {
      const _state = state[0];
      setStateId(_state.id);
      setStateName(stateName);
    }
  };

  const handleSetGender = (genderName: any) => {
    const gender = _.filter(allGenders, function (g: any) {
      return g.name === genderName;
    });
    if (gender.length) {
      const gndr = gender[0];
      setGenderId(gndr.id);
      setGender(genderName);
    }
  };

  const handleSetAllMaritalStatus = (status: any) => {
    const getStatus = _.filter(allMaritalStatus, function (s: any) {
      return s.name === status;
    });
    if (getStatus.length) {
      const sta = getStatus[0];
      setMaritalStatusId(sta.id);
      setMaritalStatus(status);
    }
  };

  const handleChangePhone = (phone: any) => {
    const regex = /^([0|+[0-9]{1,4})([0-9]{0,10})$/;
    if (phone.match(regex) || phone == '') {
      setPhone(phone);
    }
  };
  const handleSubmit = () => {
    if (!validateEmail(email)) {
      toast.error(trans('Email is not valid'));
    } else {
      callBackHandleClockIn({
        country: countryId,
        stateId: stateId,
        DOB: dob,
        email: email,
        firstName: firstName,
        lastName: lastName,
        gender: genderId,
        martialStatus: maritalStatusId,
        phone: phone,
        education: education,
        religious: religious,
        nationalityId: nationalityId,
        nationalityName: '',
      });
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="100%"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Personal Information') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '20px',
          }}
        >
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('First Name')}
              placeholder={trans('First Name')}
              value={firstName}
              onChange={(e: any) => setFirstName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            {' '}
            <CustomTextField
              type="string"
              label={trans('Last Name')}
              placeholder={trans('Last Name')}
              value={lastName}
              onChange={(e: any) => setLastName(e.target.value)}
            />
          </Grid>

          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Gender')}
              options={_.map(allGenders, (gender: any) => {
                return gender.name;
              })}
              value={gender}
              onChange={(event: any, newValue: any) => {
                handleSetGender(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomAutoComplete
              label={trans('Marital Status')}
              options={_.map(allMaritalStatus, (status: any) => {
                return status.name;
              })}
              value={maritalStatus}
              onChange={(event: any, newValue: any) => {
                handleSetAllMaritalStatus(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Country')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={countryName}
              onChange={(event: any, newValue: any) => {
                handleSetCounty(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('State')}
              options={_.map(allStates, (state: any) => {
                return state.name;
              })}
              value={stateName}
              onChange={(event: any, newValue: any) => {
                handleSetState(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomDatePicker
              label={trans('Date of Birth')}
              value={new Date(dob)}
              onChange={(newValue: any) => {
                setDOB(newValue?.$d);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomTextField
              type="string"
              placeholder={trans('Email')}
              label={trans('Email')}
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomTextField
              type="string"
              placeholder={trans('Phone')}
              label={trans('Phone')}
              value={phone}
              onChange={(e: any) => handleChangePhone(e.target.value)}
              helperText="ex. +971124578963"
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomTextField
              type="string"
              placeholder={trans('Education')}
              label={trans('Education')}
              value={education}
              onChange={(e: any) => setEducation(e.target.value)}
              helperText="ex. BE,B.SC"
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            {' '}
            <CustomTextField
              type="string"
              placeholder={trans('Religious')}
              label={trans('Religious')}
              value={religious}
              onChange={(e: any) => setReligious(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '15px' }}>
            <CustomAutoComplete
              label={trans('Nationality')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={nationality}
              onChange={(event: any, newValue: any) => {
                handleSetNationality(newValue);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default PopupModalPresenter;
